import React, { useEffect, useMemo, useState} from "react";
import {Autocomplete, Box, Button, TextField, Tooltip, Typography} from "@mui/material";
import "../App.css";
import {useNavigate} from "react-router-dom";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import {DataGrid} from '@mui/x-data-grid';
import ApiClient from "../sdk/ApiClient";
import {useKeycloak} from "@react-keycloak/web";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {DemoContainer} from "@mui/x-date-pickers/internals/demo";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';

const Stats = () => {

    const {keycloak} = useKeycloak();
    const navigate = useNavigate();

    const [missions, setMissions] = useState(null);
    const [mission, setMission] = useState(null);
    const [candidate, setCandidate] = useState("");
    const [status, setStatus] = useState({id:-1, label: "-"});
    const [from, setFrom] = useState(null);
    const [to, setTo] = useState(null);
    const [data, setData] = useState(null);
    const [rows, setRows] = useState([]);
    const [totalSend, setTotalSend] = useState(0);
    const [successCount, setSuccessCount] = useState(0);
    const [failedCount, setFailedCount] = useState(0);

    const apiClientInstance = useMemo(() => new ApiClient(keycloak.token), [keycloak.token]);

    useEffect(() => {
        const fetchMissions = async () => {
            try {
                const data = await apiClientInstance.getMissions()
                setMissions(data); // Stocke les missions dans l'état
            } catch (error) {
                console.error("Erreur lors de la récupération des missions :", error);
            }
        }
        fetchMissions();
    }, [apiClientInstance]);


    const fetchResults = async () => {
        let args = mission == null ? "?" : "?campaignId=" + mission.id;
        args += [null, "undefined", ""].findIndex(x => x === candidate) === -1 ? "&candidateNameContains=" + candidate : "";
        args += (status?.id ?? -1)  === -1 ? "" : "&status=" + status.id;
        args += from == null ? "" : "&from=" + from.format("YYYY-MM-DDTHH:mm:ss");
        args += to == null ? "" : "&to=" + to.format("YYYY-MM-DDTHH:mm:ss");

        try {
            const results = await apiClientInstance.getStats(args)
            setData(results);
        } catch (error) {
            console.error("Erreur lors de la récupération des résultats :", error);
        }
    }

    /*
     * Définition des colonnes qui seront présentées dans la table des résultats
     */
    const columns = [
        // {
        //     field: 'id',
        //     headerName: 'ID',
        //     width: 150,
        //     editable: false,
        //     hide: true,
        // },
        {
            field: 'mission',
            headerName: 'Mission',
            width: 300,
            editable: false,
        },
        {
            field: 'candidate',
            headerName: 'Candidat',
            width: 150,
            editable: false,
        },
        {
            field: 'phone',
            headerName: 'Téléphone',
            width: 150,
            editable: false,
        },
        {
            field: 'statut',
            headerName: 'Statut',
            type: 'number',
            width: 110,
            editable: false,
        },
        {
            field: 'date',
            headerName: 'Date',
            editable: false,
            width: 160,
        },
    ];

    useEffect(() => {
        const items = (data?.results?.content ??[]).map((result, index  ) => {
            return {
                id : result.id ?? result.mission.id.toString() + "-" + result.candidate.id.toString() + "-" + index ,
                mission : result.mission.label,
                candidate : result.candidate.firstName + " " + result.candidate.lastName,
                phone : result.candidate.phone,
                statut : result.sendState,
                date : dayjs(result.sendTime).format("DD/MM/YYYY HH:mm")
            };
        }).filter(Boolean)
        setRows(items)
        setTotalSend(data?.totalSend ?? 0);
        setSuccessCount(data?.successCount ?? 0)
        setFailedCount(data?.failedCount ?? 0)

    }, [data])

    const onClickMission = () => {
        navigate(`/missions`);
    }

    if (missions == null) {
        return <div>Chargement...</div>;
    }

    return (
        <Box sx={{display: "flex", flexDirection: "column", height: "100vh", padding:5}}>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: '1fr auto 1fr',
                    alignItems: 'center',
                    width: "100%",
                }}
            >
                <Button name={"next"} variant="outlined" onClick={onClickMission}  sx={{ justifySelf: 'start' }} > Retour</Button>
                <Typography variant="h4">Statistiques</Typography>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                    width: "100%",
                    textAlign: "center",
                }}
            >
                <Autocomplete
                    options={missions}
                    value={mission}
                    onChange={(_, newValue) => setMission(newValue)}
                    getOptionLabel={(option) => option.label}
                    isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                    renderInput={(params) => <TextField {...params} label="Mission" />}
                    sx={{ width: 320, marginTop:'8px' }}
                />
                <Tooltip title="Saisir tout ou partie du nom ou prénom du candidat">
                <TextField
                    label="Candidat"
                    placeholder={"Nom ou prénom du candidat"}
                    onChange={(event) => setCandidate(event.target.value)}
                    value={candidate}
                    sx={{ marginTop:'8px' }}
                />
                </Tooltip>
                <Autocomplete
                    options={[{id:-1, label: "-"},{id:0, label: "SUCCES"}, {id:1, label: "ERREUR"}]}
                    value={status}
                    onChange={(_, newValue) => setStatus(newValue)}
                    getOptionLabel={(option) => option.label}
                    isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                    renderInput={(params) => <TextField {...params} label="Statut" />}
                    sx={{ width: 320, marginTop:'8px' }}
                    defaultValue={{id:-1, label: "-"}}
                />
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DateTimePicker']}>
                        <DateTimePicker label="À partir de : "
                            value={from}
                            onChange={(newValue) => setFrom(newValue)}
                            slotProps={{ actionBar: { actions: ['clear', 'accept'] } }}
                        />
                    </DemoContainer>
                </LocalizationProvider>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DateTimePicker']}>
                        <DateTimePicker label="jusqu'à : "
                                        value={to}
                                        onChange={(newValue) => setTo(newValue)}
                                        slotProps={{ actionBar: { actions: ['clear', 'accept'] } }}
                        />
                    </DemoContainer>
                </LocalizationProvider>
                <Button
                    name={"RESULT"}
                    variant="outlined"
                    sx={{ height:'55px', marginTop:'8px' }}
                    onClick={fetchResults}>RAFRAICHIR
                </Button>
            </Box>
            <Box>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 10
                            },
                        },
                    }}
                    pageSizeOptions={[5, 10,25, 500]}
                    rowSelection={false}
                    showToolbar
                    slotProps={{
                        toolbar: {
                            csvOptions: {
                                fileName: 'results',
                                delimiter: ';',
                                utf8WithBom: true,
                                // fields: ['mission','candidate','statut','date'], // optionnel: colonnes à exporter
                            },
                        },
                    }}
                />
            </Box>
            <Box>
                <Typography >Nombre total d'envois : {totalSend}</Typography >
                <Typography >Nombre d'envois réussis : {successCount}</Typography >
                <Typography >Nombre d'envois en erreur : {failedCount}</Typography >
            </Box>
        </Box>
    );
}

export default Stats;
